import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import axios from "axios";
import React from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface IProps {
  url: string;
  onClose: () => void;
}

const PDFViewer: React.FC<IProps> = ({ url, onClose }) => {
  const [numPages, setNumPages] = React.useState<number>(0);
  const [blobPDF, setBlobPDF] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [isOpen, setIsOpen] = React.useState<boolean>(true);

  const onLoadSuccess = ({ numPages }: any) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const pages = React.useMemo(() => {
    return Array.from(new Array(numPages), (el, index) => (
      <Page
        key={index}
        pageNumber={index + 1}
        renderTextLayer={false}
        renderAnnotationLayer={false}
      />
    ));
  }, [numPages]);

  const getPDF = React.useCallback(async () => {
    setLoading(true);
    const { data } = await axios.get(url, { responseType: "blob" });
    setBlobPDF(data);
    setLoading(false);
    setIsOpen(true);
  }, [url]);

  React.useEffect(() => {
    getPDF();
  }, [getPDF]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setBlobPDF(null);
        setIsOpen(false);
        onClose();
      }}
      maxWidth="xl"
      keepMounted
    >
      <DialogContent>
        {!loading ? (
          <Document
            file={blobPDF}
            onLoadSuccess={onLoadSuccess}
            onError={(msg) => console.log(msg)}
            loading={<CircularProgress size={40} />}
          >
            {pages}
          </Document>
        ) : (
          <CircularProgress size={40} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PDFViewer;
